import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import AsideNav from "./root/AsideNav";
import { IoIosLogOut } from "react-icons/io";
import { toast } from "react-toastify";
import "./AgencyDashboard.css";
import "./UserDashboard.css";
import LocationApp from "../../sharedComponents/Location/LocationApp";
import UserTokenHandler from "../../sharedComponents/UserTokenHandler";
import GetLocalStorageUserId from "../../sharedComponents/GetLocalStorageuserId";
import { redirectToIdentityLogin } from "../../../utils/identityLogin";

const AgencyDashboard = () => {
  const [userId, setUserId] = useState(null);
  UserTokenHandler();
  useEffect(() => {
    setUserId(GetLocalStorageUserId());
  }, []);

  const move = useNavigate();
  const logoutHandle = () => {
    toast.success("Logout Successfull", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    localStorage.removeItem("sundorbonBookingUserDetails");
    localStorage.removeItem("token");
    localStorage.removeItem("Sundarbantoken");
    move("/");
  };

  const handleLoginClick = () => {
    redirectToIdentityLogin(window.location.origin);
  };

  return (
    <div className="agent-dashboard-shell user-dashboard-shell">
      <div className="hidden lg:flex absolute top-3 right-5 gap-3 z-50 items-center">
        <div className="ad-country-chip lg:mt-4">
          <LocationApp />
        </div>
        <NavLink
          to="/agency-bookings"
          className="flex items-center gap-2 font-semibold lg:mt-4 text-sm tracking-wide bg-gradient-to-r from-[#ea580c] to-[#c2410c] rounded-xl h-[44px] px-5 text-white shadow-md hover:brightness-110 transition"
        >
          Add booking
        </NavLink>
        {userId ? (
          <button
            onClick={logoutHandle}
            className="flex items-center gap-2 font-semibold lg:mt-4 text-sm tracking-wide bg-gradient-to-r from-[#6D4C41] to-[#423028] rounded-xl h-[44px] px-5 text-white shadow-md hover:brightness-110 transition"
          >
            Logout <IoIosLogOut className="text-xl" />
          </button>
        ) : (
          <button
            className="flex items-center gap-2 font-semibold lg:mt-4 text-sm tracking-wide bg-gradient-to-r from-[#6D4C41] to-[#423028] rounded-xl h-[44px] px-5 text-white shadow-md hover:brightness-110 transition"
            onClick={handleLoginClick}
          >
            Login
          </button>
        )}
      </div>

      <div className="min-h-screen lg:pt-6 xl:gap-x-[40px] lg:gap-[20px] flex lg:flex-row flex-col items-start lg:px-4 xl:px-6">
        <AsideNav />
        <div className="w-full relative z-10 lg:w-[75%] xl:w-[80%] pt-8 lg:pt-[88px] lg:px-[0px] min-h-screen">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AgencyDashboard;
